var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#1C84CF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.52485 7.26694L18.6487 11.8277C18.9035 11.955 19.0645 12.2154 19.0645 12.5003C19.0645 12.7851 18.9035 13.0455 18.6487 13.1729L9.52485 17.7336C9.26047 17.8659 8.94315 17.8309 8.71383 17.6444C8.48451 17.4579 8.38572 17.1543 8.46134 16.8685L9.61837 12.5003L8.46134 8.13203C8.38572 7.84626 8.48451 7.54269 8.71383 7.35616C8.94315 7.16963 9.26047 7.13472 9.52485 7.26694Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0519 12.5001H9.61865",
    stroke: "#1C84CF",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/SendMessage.39cffde8f9c735af9075bc2f10eb03da.svg";
export { ForwardRef as ReactComponent };